import React from 'react';

export const NoElevators = () => (
    <svg width="32" height="32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M27 8h-1.59L31 2.41 29.58 1l-7 7H5c-.55 0-1 .45-1 1v17c0 .17.05.32.13.46L1 29.59 2.41 31l4-4H27c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1Zm-6.41 2L17 13.59V10h3.59ZM6 10h9v5.59l-9 9V10Zm9 8.41V25H8.41L15 18.41ZM26 25h-9v-8.59L23.41 10H26v15Z" />
        <path d="M12 7h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1Z" />
    </svg>
);
